"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "cerreto-sannita": {
    "fac2605c": [{
      "hkey": "e3161afd",
      "slug": "cerreto-sannita",
      "name": "Cerreto Sannita",
      "primary": true,
      "skipSearch": false
    }],
    "acquara": [{
      "hkey": "e3161afd",
      "slug": "cerreto-sannita",
      "name": "Cerreto Sannita",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "0330a796": [{
      "hkey": "e3161afd",
      "slug": "cerreto-sannita",
      "name": "Cerreto Sannita",
      "primary": true,
      "skipSearch": false
    }],
    "cerquelle": [{
      "hkey": "e3161afd",
      "slug": "cerreto-sannita",
      "name": "Cerreto Sannita",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "ba3ca1fe": [{
      "hkey": "e3161afd",
      "slug": "cerreto-sannita",
      "name": "Cerreto Sannita",
      "primary": true,
      "skipSearch": false
    }],
    "cesine-di-sotto": [{
      "hkey": "e3161afd",
      "slug": "cerreto-sannita",
      "name": "Cerreto Sannita",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "3b278723": [{
      "hkey": "e3161afd",
      "slug": "cerreto-sannita",
      "name": "Cerreto Sannita",
      "primary": true,
      "skipSearch": false
    }],
    "contrade-cesine-di-sopra": [{
      "hkey": "e3161afd",
      "slug": "cerreto-sannita",
      "name": "Cerreto Sannita",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "0aa862df": [{
      "hkey": "e3161afd",
      "slug": "cerreto-sannita",
      "name": "Cerreto Sannita",
      "primary": true,
      "skipSearch": false
    }],
    "madonna-del-carmine": [{
      "hkey": "e3161afd",
      "slug": "cerreto-sannita",
      "name": "Cerreto Sannita",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "93c685f3": [{
      "hkey": "e3161afd",
      "slug": "cerreto-sannita",
      "name": "Cerreto Sannita",
      "primary": true,
      "skipSearch": false
    }],
    "madonna-del-soccorso": [{
      "hkey": "e3161afd",
      "slug": "cerreto-sannita",
      "name": "Cerreto Sannita",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "8decfbd0": [{
      "hkey": "e3161afd",
      "slug": "cerreto-sannita",
      "name": "Cerreto Sannita",
      "primary": true,
      "skipSearch": false
    }],
    "madonna-delle-grazie": [{
      "hkey": "e3161afd",
      "slug": "cerreto-sannita",
      "name": "Cerreto Sannita",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "7d0384c6": [{
      "hkey": "e3161afd",
      "slug": "cerreto-sannita",
      "name": "Cerreto Sannita",
      "primary": true,
      "skipSearch": false
    }],
    "pezzalonga": [{
      "hkey": "e3161afd",
      "slug": "cerreto-sannita",
      "name": "Cerreto Sannita",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "5e9cbae8": [{
      "hkey": "e3161afd",
      "slug": "cerreto-sannita",
      "name": "Cerreto Sannita",
      "primary": true,
      "skipSearch": false
    }],
    "raone": [{
      "hkey": "e3161afd",
      "slug": "cerreto-sannita",
      "name": "Cerreto Sannita",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "fa0a7304": [{
      "hkey": "e3161afd",
      "slug": "cerreto-sannita",
      "name": "Cerreto Sannita",
      "primary": true,
      "skipSearch": false
    }],
    "san-giovanni": [{
      "hkey": "e3161afd",
      "slug": "cerreto-sannita",
      "name": "Cerreto Sannita",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "64d34918": [{
      "hkey": "e3161afd",
      "slug": "cerreto-sannita",
      "name": "Cerreto Sannita",
      "primary": true,
      "skipSearch": false
    }],
    "trocchia": [{
      "hkey": "e3161afd",
      "slug": "cerreto-sannita",
      "name": "Cerreto Sannita",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;